var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortDescending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83854 4.17708C5.83854 3.71685 5.46545 3.34375 5.00521 3.34375C4.54497 3.34375 4.17188 3.71685 4.17188 4.17708V14.2486L3.09446 13.1712C2.76903 12.8457 2.24139 12.8457 1.91595 13.1712C1.59052 13.4966 1.59052 14.0242 1.91595 14.3497L3.8267 16.2604C4.47757 16.9113 5.53285 16.9113 6.18372 16.2604L8.09446 14.3497C8.4199 14.0242 8.4199 13.4966 8.09446 13.1712C7.76903 12.8457 7.24139 12.8457 6.91595 13.1712L5.83854 14.2486V4.17708Z",
    fill: "#6F767E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 14.1764C10 14.6367 10.3731 15.0098 10.8333 15.0098H17.5C17.9602 15.0098 18.3333 14.6367 18.3333 14.1764C18.3333 13.7162 17.9602 13.3431 17.5 13.3431H10.8333C10.3731 13.3431 10 13.7162 10 14.1764Z",
    fill: "#6F767E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10.0091C10 9.54888 10.3731 9.17578 10.8333 9.17578H15C15.4602 9.17578 15.8333 9.54888 15.8333 10.0091C15.8333 10.4694 15.4602 10.8424 15 10.8424H10.8333C10.3731 10.8424 10 10.4694 10 10.0091Z",
    fill: "#6F767E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 5.8431C10 5.38286 10.3731 5.00977 10.8333 5.00977H12.5C12.9602 5.00977 13.3333 5.38286 13.3333 5.8431C13.3333 6.30334 12.9602 6.67643 12.5 6.67643H10.8333C10.3731 6.67643 10 6.30334 10 5.8431Z",
    fill: "#6F767E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDescending);
export default __webpack_public_path__ + "static/media/sort_descending.ea12da80ce8326bb79e5905105bef57e.svg";
export { ForwardRef as ReactComponent };